import {TFunction} from 'i18next';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {validatePasswordsMatch, validatePasswordStrength} from '../../../../../../utils/validators';

export interface ChangePasswordFormValues {
  oldPassword: string;
  newPassword: string;
  repeatNewPassword: string;
}

export const getTextFieldStyles = () => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: orangeColors[7],
    borderRadius: '4px',
    color: greenColors[700],
    '& fieldset': {
      borderColor: orangeColors[5],
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: orangeColors[5],
    },
    '&.Mui-focused': {
      backgroundColor: orangeColors[3],
    },
    '&.Mui-focused fieldset': {
      borderColor: orangeColors[3],
    },
  },
  '& .MuiInputBase-input': {
    padding: '8px 12px',
  },
});

export const validateChangePasswordForm = (
  values: ChangePasswordFormValues,
  t: TFunction
): Partial<ChangePasswordFormValues> => {
  const errors: Partial<ChangePasswordFormValues> = {};

  if (!values.oldPassword) {
    errors.oldPassword = t('shared.required') || '';
  }

  if (!values.newPassword) {
    errors.newPassword = t('shared.required') || '';
  } else if (!validatePasswordStrength(values.newPassword)) {
    errors.newPassword = t('registration.signUp.formLabels.errorMessages.invalidPassword') || '';
  }

  if (!values.repeatNewPassword) {
    errors.repeatNewPassword = t('shared.required') || '';
  } else if (!validatePasswordsMatch(values.newPassword, values.repeatNewPassword)) {
    errors.repeatNewPassword = t('passwordReset.passwordNotMatching') || '';
  }

  return errors;
};

export const initialFormValues: ChangePasswordFormValues = {
  oldPassword: '',
  newPassword: '',
  repeatNewPassword: '',
};
